import {combineReducers} from '@reduxjs/toolkit';
import customersList from './customers-list.slice';
import createCustomer from './create-costumer.slice';

const reducer = combineReducers({
  customersList,
  createCustomer
});

export default reducer;